"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var theme = require("../../theme.scss");
var mobx_react_1 = require("mobx-react");
var ui_1 = require("@vidazoo/ui");
var moment = require("moment");
var utils_1 = require("../../../../utils");
var SettingRow = /** @class */ (function (_super) {
    tslib_1.__extends(SettingRow, _super);
    function SettingRow() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (e) {
            var _a = _this.props, setting = _a.setting, updateSetting = _a.updateSetting;
            var value = utils_1.normalizeEventValue(e);
            updateSetting(setting._id, e.target.name, value);
        };
        _this.onOpen = function (app, entityId, params) {
            switch (app) {
                case "Nightwatch":
                    window.open("https://vidazoo-nightwatch.herokuapp.com/test/" + entityId + "/edit");
                    break;
                case "Vroku":
                    window.open("https://os.vidazoo.com/app/vroku/edit-host?id=" + entityId);
                    break;
                case "Alert Rules":
                    if (params && params.entityType) {
                        if (params.entityType === "Alert Rule") {
                            window.open("https://bo.vidazoo.com/alert-rule/" + entityId + "/edit");
                        }
                        else if (params.entityType === "Smart Alert") {
                            window.open("https://bo.vidazoo.com/smart-alert/" + entityId + "/edit");
                        }
                    }
                    break;
            }
        };
        _this.getEntityName = function (app, params) {
            switch (app) {
                case "Alert Rules":
                    if (params && params.entityType) {
                        return params.entityName + " (" + params.entityType + ")";
                    }
                    break;
                default:
                    return params.entityName;
            }
        };
        _this.onDelete = function () {
            var _a = _this.props, setting = _a.setting, onDelete = _a.onDelete;
            onDelete(setting);
        };
        return _this;
    }
    SettingRow.prototype.render = function () {
        var _this = this;
        var _a = this.props, setting = _a.setting, phone = _a.phone, index = _a.index, columnsWidth = _a.columnsWidth, freezeColumnIndex = _a.freezeColumnIndex;
        return (React.createElement(ui_1.DataGridRow, { className: theme.row, index: index, columnsWidth: columnsWidth, key: index, freezeColumnIndex: freezeColumnIndex },
            setting.params && setting.params.entityId ?
                React.createElement(ui_1.DataGridColumn, { className: theme.column },
                    React.createElement("div", { className: theme.captionLink, onClick: function () { return _this.onOpen(setting.app, setting.params.entityId, setting.params); } }, this.getEntityName(setting.app, setting.params)))
                : React.createElement(ui_1.DataGridColumn, { className: theme.column },
                    React.createElement("div", { className: theme.caption }, setting.name)),
            React.createElement(ui_1.DataGridColumn, { className: theme.column }, setting.app),
            React.createElement(ui_1.DataGridColumn, { className: theme.column },
                React.createElement(ui_1.Switch, { disabled: setting.type === "custom", name: "notification", label: "Notification", checked: setting.notification, onChange: this.onChange })),
            React.createElement(ui_1.DataGridColumn, { className: theme.column },
                React.createElement(ui_1.Switch, { name: "email", label: "Email", checked: setting.email, onChange: this.onChange })),
            React.createElement(ui_1.DataGridColumn, { className: theme.column },
                React.createElement(ui_1.Switch, { name: "sms", label: "Sms", checked: setting.sms, disabled: !phone, onChange: this.onChange })),
            React.createElement(ui_1.DataGridColumn, { className: theme.column }, moment(setting.created).format("LLL")),
            React.createElement(ui_1.DataGridColumn, { className: theme.column }, setting.lastSent ? moment(setting.lastSent).format("LLL") : ""),
            React.createElement(ui_1.DataGridColumn, { className: theme.column },
                React.createElement("div", { className: theme.links },
                    React.createElement(ui_1.LinkButton, { onClick: this.onDelete, iconName: "icon-delete", iconSize: 1.8 })))));
    };
    SettingRow = tslib_1.__decorate([
        mobx_react_1.observer
    ], SettingRow);
    return SettingRow;
}(React.Component));
exports.default = SettingRow;
